import { AvailableIntegration, ConnectedIntegration } from '@kindo/universal';

export interface AvailableIntegrationWithDisplayName
  extends AvailableIntegration {
  displayName: string;
}

export interface ConnectedIntegrationWithDisplayName
  extends ConnectedIntegration {
  displayName: string;
}

export const isConnectedIntegration = (
  integration:
    | AvailableIntegrationWithDisplayName
    | ConnectedIntegrationWithDisplayName
): integration is ConnectedIntegrationWithDisplayName => 'id' in integration;

export const isAvailableIntegration = (
  integration:
    | AvailableIntegrationWithDisplayName
    | ConnectedIntegrationWithDisplayName
): integration is AvailableIntegrationWithDisplayName => !('id' in integration);
